import Text from '@cartwhl/ui/base/Text';
import PlusIcon from '@cartwhl/ui/icons/PlusIcon';

interface AdditionalChainAddCardProps {
  familyLabel: string;
  chainName: string;
  disabled: boolean;
  onAddChain: (chainName: string) => void;
}

export default function AdditionalChainAddCard({
  familyLabel,
  chainName,
  disabled,
  onAddChain,
}: AdditionalChainAddCardProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        onAddChain(chainName);
      }}
      aria-label={`Add ${familyLabel} chain`}
      className={`group flex min-h-[80px] w-full flex-col items-center justify-center rounded-xl border border-dashed px-4 py-3 text-center transition-colors ${
        disabled
          ? 'border-white/10 bg-white/5 opacity-60 dark:border-gray-60/20 dark:bg-gray-75/10'
          : 'border-white/20 bg-white/10 hover:bg-white/15 dark:border-gray-60/30 dark:bg-gray-75/15 dark:hover:bg-gray-75/25'
      }`}
    >
      <span
        className={`mb-2 inline-flex h-9 w-9 items-center justify-center rounded-full transition-[background-color,box-shadow,transform] ${
          disabled
            ? 'bg-white/90 dark:bg-gray-90/90'
            : 'bg-white/90 group-hover:scale-105 group-hover:bg-blue-50/15 group-hover:shadow-sm dark:bg-gray-90/90 dark:group-hover:bg-blue-50/15'
        }`}
      >
        <PlusIcon
          className={`h-4 w-4 transition-colors ${
            disabled ? 'text-primary' : 'text-primary group-hover:text-blue-50'
          }`}
        />
      </span>
      <Text variant="studio/body/medium/sm" className="text-primary block">
        {familyLabel}
      </Text>
    </button>
  );
}
